import { get, post, put, patch, del } from '../http/http';
// 应用管理
export default {
  getList: (val) => get('/application', val), // 查询列表
  addList: (val) => post('/application', val), // 添加
  delList: (val) => del(`/application/${val}`), // 删除
  putList: (val) => put(`/application/${val.id}`, val), // 编辑
  patch: (val) => patch(`/application/${val}`), // 恢复
  getInfo: (val) => get(`/application/${val}`), // 根据id查询应用详情
  getInfoList: (val) => get(`/application/app/${val}`), // 根据id查询应用详情
  bind: (val) => put('/application/grant/app', val), // 授权产品
  unbind: (val) => put(`/application/app/${val.app_id}/revoke/${val.product_id}`), // 解绑
  authorization: (val) => put('/application/grants/app', val), // 授权多个产品
  reset: (val) => put(`/application/${val}/reset`), // 重置
  pass: (val) => post(`/application/${val}/approval/pass`), // 通过
  refuse: (val) => post(`/application/${val}/approval/no-pass`), // 拒绝
  getLog: (id, val) => get(`/application/log/${id}`, val), // 获取应用日志
  putDataCenter: (val) => put('/application/grant/platform/dataCenter/',val), // 授权数据中心
  getDataCenterOptions: (id) => get(`/application/grant/platform/dataCenter/${id}`) // 根据ID获取授权平台和数据中心
};
